import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Section, Title } from "@/components/UI";
import { ProviderSection } from "@/components/contacting";
import { useRefsContext } from "@/contexts/ref";
import { useI18n } from "@/contexts/i18n";
export const PropertyProvider = () => {
    const { t } = useI18n();
    const { propertyProviderRef } = useRefsContext();
    return (_jsxs(Section, { ref: propertyProviderRef, children: [_jsx(Title, { variant: "section", title: t("contact.provider.property_provider") }), _jsx(ProviderSection, {})] }));
};
